import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Button,
  Checkbox,
  Radio,
  Label,
  Container,
  Divider,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import axios from "axios";
import AsyncSelect from "react-select/async";
import isEmpty from "validator/lib/isEmpty";
import isEmail from "validator/lib/isEmail";
import equals from "validator/lib/equals";
import matches from "validator/lib/matches";
import contains from "validator/lib/contains";
import isLength from "validator/lib/isLength";
import { connect } from "react-redux";
import InlineError from "../messages/InlineError";
import { fetchPractitionerAgreements } from "../../actions/agreementActions";
import { validatePractitioner } from "../../actions/auth";
import { getCitiesList } from "../../actions/citiesActions";
import ModalPage from "../pages/ModalPage";

const optionStyle = {
  marginTop: "-23px",
  marginLeft: "24px",
};

class SignupForm extends Component {
  state = {
    data: {
      userID: "",
      names: "",
      lastname1: "",
      lastname2: "",
      email_address: "",
      email_addressConfirmation: "",
      birthdate: "",
      username: "",
      password: "",
      passwordConfirmation: "",
      medical_record: "",
      specialty: "",
      city: "",
      address: "",
      consulting_room: "",
      phone: "",
      fullname: "",
      code: "",
      associate: 0,
      gender: "",
      agreements: [],
    },
    agreements: [],
    showModal: false,
    policy: "",
    policy_header: "",
    isLoading: true,
    errors: {},
  };

  onChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  async getOptionsForCities(input) {
    if (input.length > 3) {
      await this.props.getCitiesList(input);
      const citiesOptions = this.props.ciudades.map((city, index) => ({
        label: city.city + ", " + city.state,
        value: city.code,
        ...city,
      }));
      return citiesOptions;
    } else {
      return [];
    }
  }

  handleChangeCity = (item) => {
    this.setState({ data: { ...this.state.data, city: item.value } });
  };

  validate = (data) => {
    const errors = {};

    if (isEmpty(data.userID)) errors.userID = "No puede estar en blanco.";

    if (isEmpty(data.names)) errors.names = "No puede estar en blanco.";

    if (isEmpty(data.lastname1)) errors.lastname1 = "No puede estar en blanco.";

    // if (isEmpty(data.lastname2)) errors.lastname2 = "No puede estar en blanco.";

    if (isEmpty(data.email_address))
      errors.email_address = "No puede estar en blanco.";

    if (!isEmail(data.email_address))
      errors.email_address = "La dirección de correo está mal escrita.";

    if (contains(data.email_address, " ")) {
      errors.email_address = "La contraseña no debe contener espacios";
    }

    if (isEmpty(data.email_addressConfirmation))
      errors.email_addressConfirmation = "No puede estar en blanco.";

    if (!equals(data.email_address, data.email_addressConfirmation)) {
      errors.email_addressConfirmation =
        "Las direcciones de correo no son iguales";
    }

    if (isEmpty(data.birthdate)) errors.birthdate = "No puede estar en blanco.";

    if (isEmpty(data.gender)) errors.gender = "Debe elegir uno de los dos.";

    if (isEmpty(data.username)) errors.username = "No puede estar en blanco.";

    if (!matches(data.username, /^[a-z0-9\-_.]+$/i)) {
      errors.username =
        "El nombre de usuario solo puede contener letras, números o los caracteres guión ( - ), guión bajo ( _ ) o punto ( . )";
    }

    if (isEmpty(data.password)) errors.password = "No puede estar en blanco.";

    if (contains(data.password, " ")) {
      errors.password = "La contraseña no debe contener espacios";
    }

    if (!isLength(data.password, { min: 12, max: 30 })) {
      errors.password = "La contraseña debe contener de 12 a 30 caracteres";
    } else {
      if (
        !matches(
          data.password,
          /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?['\/~`!@#$%^&*()_\-+={}[]|;:"<>,.?\\]).{12,30}$/g
        )
      ) {
        errors.password = `La contraseña debe estar compuesta por al menos 1 mayúscula, 1 minúscula, 4 números y 1 caracter especial`;
      }
    }
    if (isEmpty(data.passwordConfirmation))
      errors.passwordConfirmation = "No puede estar en blanco.";

    if (!equals(data.password, data.passwordConfirmation)) {
      errors.passwordConfirmation = "Las contraseñas no son iguales";
    }

    if (isEmpty(data.medical_record))
      errors.medical_record = "No puede estar en blanco.";

    // if (isEmpty(data.specialty)) errors.specialty = "No puede estar en blanco.";

    if (isEmpty(data.city)) errors.city = "No puede estar en blanco.";

    if (isEmpty(data.address)) errors.address = "No puede estar en blanco.";

    // if (isEmpty(data.consulting_room))
    //   errors.consulting_room = "No puede estar en blanco.";

    if (isEmpty(data.phone)) errors.phone = "No puede estar en blanco.";

    return errors;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      validatePractitioner(this.state.data).then((data) => {
        if (Object.keys(data).length > 0) {
          if (this.state.data.username === data.username) {
            this.setState({
              data: { ...this.state.data, username: "" },
              errors: {
                ...this.state.errors,
                username: `El usuario "${data.username}" ya existe.`,
              },
            });
          }
          if (this.state.data.userID === data.userID) {
            this.setState({
              data: { ...this.state.data, userID: "" },
              errors: {
                ...this.state.errors,
                userID: `La identificación "${data.userID}" ya existe.`,
              },
            });
          }
        } else {
          this.props.submit(this.state.data);
        }
      });
    }
  };
  _onChangeCheckbox = (e, data) => {
    let proceed = true;
    const agreements = this.state.data.agreements.map((agreement, idx) => {
      if (data.name === agreement.name) {
        agreement.accepted = data.checked;
      }
      proceed = proceed && agreement.accepted;
      return agreement;
    });
    this.setState({
      data: { ...this.state.data, agreements: agreements, proceed: proceed },
    });
  };

  createMarkup = (message) => {
    return { __html: message };
  };

  _renderOptions = (agreements) => {
    const options = agreements.map((el, idx) => {
      return (
        <Form.Field key={idx}>
          <Checkbox
            name={el.name}
            id={el.id}
            onChange={this._onChangeCheckbox}
          />
          <div
            style={optionStyle}
            dangerouslySetInnerHTML={this.createMarkup(el.short_message)}
          />
        </Form.Field>
      );
    });
    return options;
  };

  _onChangeRadioButton = (e, { value }) =>
    this.setState({ data: { ...this.state.data, gender: value } });

  _openModal = (policy) => {
    // verify that the data.agreement related to this policy is false
    if (!this.state.data[policy.name]) {
      this.setState({
        showModal: true,
        data: { ...this.state.data, [policy.name]: true },
        policy: policy.policy,
        policy_header: policy.header,
      });
    } else {
      this.setState({
        data: { ...this.state.data, [policy.name]: false },
      });
    }
  };

  _closeModal = () => {
    this.setState({
      showModal: false,
      policy: "",
      policy_header: "",
    });
  };

  componentDidMount() {
    // here must make the API Calls for agreements.
    this.props.getCitiesList();
    axios.get(`/api/agreements/MEDICO`).then((resp) => {
      let agreements = [];
      resp.data.agreements.forEach((agreement) => {
        agreements.push(agreement);
      });
      this.setState({
        agreements,
        isLoading: false,
        data: {
          ...this.state.data,
          names: this.props.Nombres,
          lastname1: this.props.Apellido1,
          lastname2: this.props.Apellido2,
          address: this.props.Direccion,
          city: this.props.Ciudad,
          phone: this.props.Telefono,
          email_address: this.props.DirEmail,
          medical_record: this.props.NumRegistro,
          fullname: this.props.NombreCompleto,
          userID: this.props.practitioner_id,
          username: this.props.userid,
          password: this.props.password,
          agreements,
        },
      });
    });
    //Pre llenado del formulario
  }
  render() {
    const { data, errors, isLoading, agreements } = this.state;
    // const citiesOptions = this.props.ciudades.map((ent, index) => ({
    //   key: ent.code,
    //   text: ent.city + "-" + ent.state,
    //   value: ent.city
    // }));
    // console.log(this.state);
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let yyyy = today.getFullYear();
    let y_18 = yyyy - 18;
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    let maxDate = y_18 + "-" + mm + "-" + dd;

    let _render = isLoading ? (
      <Dimmer active inverted>
        <Loader>Cargando...</Loader>
      </Dimmer>
    ) : (
      <Form onSubmit={this.onSubmit} loading={isLoading}>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.userID}>
            <label htmlFor="userID">Documento de Identidad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Escriba su documento de identidad"
              id="userID"
              name="userID"
              disabled={this.props.userid === "" ? true : false}
              onChange={this.onChange}
              value={data.userID}
            />
            {errors.userID && <InlineError text={errors.userID} />}
          </Form.Field>
          <Form.Field error={!!errors.names}>
            <label htmlFor="names">Nombre(s) *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="names"
              name="names"
              onChange={this.onChange}
              value={data.names}
            />
            {errors.names && <InlineError text={errors.names} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.lastname1}>
            <label htmlFor="lastname1">Primer apellido *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="lastname1"
              name="lastname1"
              onChange={this.onChange}
              value={data.lastname1}
            />
            {errors.lastname1 && <InlineError text={errors.lastname1} />}
          </Form.Field>
          <Form.Field error={!!errors.lastname2}>
            <label htmlFor="lastname2">Segundo Apellido</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="lastname2"
              name="lastname2"
              onChange={this.onChange}
              value={data.lastname2}
            />
            {errors.lastname2 && <InlineError text={errors.lastname2} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.birthdate}>
            <label htmlFor="birthdate">Fecha de nacimiento *</label>
            <input
              className="u-full-width"
              type="date"
              placeholder=""
              id="birthdate"
              name="birthdate"
              min={"1920-01-01"}
              max={maxDate}
              onChange={this.onChange}
              value={data.birthdate}
            />
            {errors.birthdate && <InlineError text={errors.birthdate} />}
          </Form.Field>
          <Form.Field error={!!errors.gender}>
            <label htmlFor="gender">Género *</label>
            <Form.Group inline>
              <Form.Field
                control={Radio}
                label="Femenino"
                name="genero"
                value="0"
                checked={data.gender === "0"}
                onChange={this._onChangeRadioButton}
              />
              <Form.Field
                control={Radio}
                label="Masculino"
                name="genero"
                value="1"
                checked={data.gender === "1"}
                onChange={this._onChangeRadioButton}
              />
            </Form.Group>
            {errors.gender && <InlineError text={errors.gender} />}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.medical_record}>
            <label htmlFor="medical_record">Registro Médico *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="medical_record"
              name="medical_record"
              onChange={this.onChange}
              value={data.medical_record}
            />
            {errors.medical_record && (
              <InlineError text={errors.medical_record} />
            )}
          </Form.Field>
          <Form.Field error={!!errors.specialty}>
            <label htmlFor="specialty">Especialidad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="specialty"
              name="specialty"
              onChange={this.onChange}
              value={data.specialty}
            />
            {errors.specialty && <InlineError text={errors.specialty} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.city}>
            <label htmlFor="city">Ciudad *</label>
            <AsyncSelect
              isClearable
              // defaultInputValue={defaultCity}
              // isDisabled={values.PaisDeProcedencia !== "170"}
              name="city"
              placeholder="Escriba el nombre del Ciudad"
              onChange={this.handleChangeCity}
              loadOptions={(e) => this.getOptionsForCities(e)}
            />
            {errors.city && <InlineError text={errors.city} />}
          </Form.Field>

          <Form.Field error={!!errors.address}>
            <label htmlFor="address">Dirección *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="address"
              name="address"
              onChange={this.onChange}
              value={data.address}
            />
            {errors.address && <InlineError text={errors.address} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.consulting_room}>
            <label htmlFor="consulting_room">Consultorio</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="consulting_room"
              name="consulting_room"
              onChange={this.onChange}
              value={data.consulting_room}
            />
            {errors.consulting_room && (
              <InlineError text={errors.consulting_room} />
            )}
          </Form.Field>
          <Form.Field error={!!errors.phone}>
            <label htmlFor="phone">Teléfono *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Teléfono fijo o celular"
              id="phone"
              name="phone"
              onChange={this.onChange}
              value={data.phone}
            />
            {errors.phone && <InlineError text={errors.phone} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.email_address}>
            <label htmlFor="email_address">Correo Electrónico *</label>
            <input
              className="u-full-width"
              type="email"
              placeholder=""
              id="email_address"
              name="email_address"
              onChange={this.onChange}
              value={data.email_address}
            />
            {errors.email_address && (
              <InlineError text={errors.email_address} />
            )}
          </Form.Field>
          <Form.Field error={!!errors.email_addressConfirmation}>
            <label htmlFor="email_addressConfirmation">
              Confirmar Correo Electrónico *
            </label>
            <input
              className="u-full-width"
              type="email"
              placeholder="Escriba de nuevo la dirección correo"
              id="email_addressConfirmation"
              name="email_addressConfirmation"
              onChange={this.onChange}
              value={data.email_addressConfirmation}
            />
            {errors.email_addressConfirmation && (
              <InlineError text={errors.email_addressConfirmation} />
            )}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.username}>
            <label htmlFor="username">Usuario *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="username"
              name="username"
              autoComplete="false"
              onChange={this.onChange}
              value={data.username}
            />
            {errors.username && <InlineError text={errors.username} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.password}>
            <label htmlFor="password">Contraseña *</label>
            <input
              className="u-full-width"
              type="password"
              placeholder=""
              id="password"
              name="password"
              autoComplete="new-password"
              onChange={this.onChange}
              value={data.password}
            />
            {errors.password && <InlineError text={errors.password} />}
          </Form.Field>
          <Form.Field error={!!errors.passwordConfirmation}>
            <label htmlFor="passwordConfirmation">Confirmar contraseña *</label>
            <input
              className="u-full-width"
              type="password"
              placeholder="Escriba de nuevo su contraseña"
              id="passwordConfirmation"
              name="passwordConfirmation"
              onChange={this.onChange}
              value={data.passwordConfirmation}
            />
            {errors.passwordConfirmation && (
              <InlineError text={errors.passwordConfirmation} />
            )}
          </Form.Field>
        </Form.Group>
        <Form.Field>
          <label>Tratamiento de datos personales</label>
        </Form.Field>

        <Label as="a" color="red" ribbon>
          Importante
        </Label>
        <Container>
          Siempre pensando en proteger y darle un correcto uso a sus datos
          personales en cumplimiento de la Ley estatutaria 1581 del 17 de
          octubre de 2012 y demás disposiciones normativas, el derecho para
          acceder a nuestra plataforma de resultados, está garantizado si usted
          diligencia todos los campos del siguiente formulario y acepta los
          siguientes términos y condiciones:
        </Container>
        <Divider />

        {this._renderOptions(agreements)}
        <Button
          color="blue"
          content="Registrarse"
          icon="sign in"
          labelPosition="left"
          disabled={!data.proceed}
        />
        <Link to="/" style={{ marginLeft: "20px" }}>
          Cancelar
        </Link>
      </Form>
    );
    return _render;
  }
}

const mapStateToProps = (state) => {
  const { cities } = state;

  if (state.user.resp && state.user.resp.medico) {
    // Los datos vienen de la tabla medicos
    const {
      userid,
      password,
      email,
      direccion,
      ciudad,
      tel_consultorio,
      registro,
      nombre,
      apellidos,
      medico,
    } = state.user.resp;

    return {
      Nombres: nombre,
      Apellido1: apellidos,
      Direccion: direccion,
      Ciudad: ciudad,
      Telefono: tel_consultorio,
      DirEmail: email,
      NumRegistro: registro,
      NombreCompleto: medico.toUpperCase(),
      practitioner_id: "",
      userid,
      password,
      ciudades: cities.cities,
    };
  } else if (state.user.data && state.user.data.Cedula) {
    // Los datos vienen de la tabla medicos_4d
    const { Cedula } = state.user.data;

    return {
      Cedula: "",
      Ciudad: "",
      practitioner_id: Cedula,
      userid: "",
      password: "",
      ciudades: cities.cities,
    };
  } else {
    // sin información del medico, solo la cédula que ingresó
    return {
      Cedula: "",
      Nombres: "",
      Apellido1: "",
      Apellido2: "",
      NombreCompleto: "",
      Direccion: "",
      DirEmail: "",
      NumRegistro: "",
      Especialidad: "",
      Ciudad: "",
      Telefono: "",
      practitioner_id: state.user.data.practitioner_id,
      userid: "",
      password: "",
      ciudades: cities.cities,
    };
  }
};

export default connect(mapStateToProps, { getCitiesList })(SignupForm);
